function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-ENSURE"
}, /*#__PURE__*/React.createElement("rect", {
  width: 255,
  height: 25.23
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "ENSURE",
  clipPath: "url(#clip-ENSURE)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_63545"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_143918",
  width: 18.72,
  height: 3.973,
  transform: "translate(0 21.266)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_143919",
  width: 18.72,
  height: 3.973,
  transform: "translate(0 10.723)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_143920",
  width: 18.72,
  height: 3.973,
  transform: "translate(0 0.182)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_36484",
  d: "M-462.215,46.029h5.032l11.627,15.279V46.029h5.387v24.82h-4.641l-12.016-15.78v15.78h-5.389Z",
  transform: "translate(489.225 -45.604)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_36485",
  d: "M-438.317,67.3l3.226-3.864a11.412,11.412,0,0,0,7.409,3.02c2.233,0,3.581-.888,3.581-2.33v-.071c0-1.381-.85-2.089-5-3.155-5-1.275-8.224-2.658-8.224-7.585v-.071c0-4.517,3.615-7.5,8.684-7.5a14.366,14.366,0,0,1,9.215,3.156l-2.835,4.113a11.635,11.635,0,0,0-6.45-2.447c-2.092,0-3.191.957-3.191,2.161V52.8c0,1.631,1.063,2.161,5.353,3.26,5.033,1.313,7.869,3.121,7.869,7.446v.07c0,4.926-3.757,7.691-9.111,7.691A15.783,15.783,0,0,1-438.317,67.3Z",
  transform: "translate(495.174 -45.675)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_36486",
  d: "M-416.264,60.209V46.034h5.458V60.068c0,4.04,2.022,6.13,5.353,6.13s5.353-2.019,5.353-5.954V46.029h5.465v14c0,7.515-4.218,11.2-10.874,11.2S-416.264,67.51-416.264,60.209Z",
  transform: "translate(500.664 -45.604)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_36487",
  d: "M-391.657,46.029h11.343c3.156,0,5.6.885,7.232,2.525a7.8,7.8,0,0,1,2.137,5.673V54.3a7.7,7.7,0,0,1-5.318,7.692l6.054,8.861h-6.381l-5.318-7.946H-386.2v7.946h-5.461Zm10.99,12.052c2.658,0,4.18-1.408,4.18-3.509V54.5c0-2.331-1.631-3.546-4.289-3.546h-5.42v7.125Z",
  transform: "translate(506.789 -45.604)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_36488",
  d: "M-368.3,46.029h18.718v4.856h-13.3v5.034h11.7v4.855h-11.7v5.221H-349.4v4.855h-18.9Z",
  transform: "translate(512.604 -45.604)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_36489",
  d: "M-347.751,66.979l3.758-3.581A7.569,7.569,0,0,0-338,66.377c2.057,0,3.51-1.165,3.51-3.014v-.07c0-2.021-1.809-3.156-4.855-3.156h-2.271l-.851-3.463,5.919-5.955H-346.3v-4.69h16.766v4.114l-6.274,5.989c3.367.567,6.662,2.339,6.662,6.948v.072c0,4.677-3.4,8.117-8.933,8.117A12.055,12.055,0,0,1-347.751,66.979Z",
  transform: "translate(517.719 -45.604)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_36490",
  d: "M-323.892,68.694c-1.807-1.807-2.941-4.466-2.941-9.393V59.23c0-7.657,3.473-13.541,10.874-13.541a11.51,11.51,0,0,1,7.767,2.729l-2.871,4.219a7.653,7.653,0,0,0-5.071-1.986c-3.084,0-4.644,2.482-5,5.744a8.584,8.584,0,0,1,5.141-1.6c4.927,0,8.719,2.73,8.719,7.906v.074c0,5.069-4.078,8.579-9.465,8.579A9.426,9.426,0,0,1-323.892,68.694Zm11.2-5.671v-.07c0-2.092-1.633-3.617-4.325-3.617s-4.253,1.489-4.253,3.579v.072c0,2.091,1.629,3.689,4.324,3.689S-312.69,65.149-312.69,63.023Z",
  transform: "translate(522.926 -45.689)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_36491",
  d: "M-305.207,58.59v-.07c0-7.2,4.467-12.831,11.06-12.831,6.558,0,10.989,5.565,10.989,12.76v.071c0,7.2-4.432,12.833-11.069,12.833S-305.207,65.788-305.207,58.59Zm16.449,0v-.07c0-4.5-2.2-7.9-5.459-7.9s-5.389,3.3-5.389,7.833v.071c0,4.537,2.164,7.906,5.46,7.906S-288.758,63.094-288.758,58.59Z",
  transform: "translate(528.309 -45.689)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_36492",
  d: "M-286.565,65.562v.149a1.134,1.134,0,0,0,.076.443.749.749,0,0,0,.194.283.776.776,0,0,0,.28.154,1.062,1.062,0,0,0,.312.046,1.5,1.5,0,0,0,.366-.042.75.75,0,0,0,.295-.144.713.713,0,0,0,.195-.262,1,1,0,0,0,.071-.388.706.706,0,0,0-.173-.482,1.905,1.905,0,0,0-.431-.351c-.183-.11-.368-.21-.56-.3a3.423,3.423,0,0,1-.562-.339,1.855,1.855,0,0,1-.431-.456,1.173,1.173,0,0,1-.17-.648,1.488,1.488,0,0,1,.114-.608,1.245,1.245,0,0,1,.319-.441,1.349,1.349,0,0,1,.486-.27,1.967,1.967,0,0,1,.6-.09,1.528,1.528,0,0,1,1.1.36,1.435,1.435,0,0,1,.341,1.155h-.689a1.189,1.189,0,0,0-.161-.682.7.7,0,0,0-.635-.257,1.091,1.091,0,0,0-.291.039.734.734,0,0,0-.256.13.626.626,0,0,0-.183.237.843.843,0,0,0-.067.354.681.681,0,0,0,.172.477,1.842,1.842,0,0,0,.432.346c.17.1.359.194.559.3a3.522,3.522,0,0,1,.562.341,1.721,1.721,0,0,1,.429.471,1.258,1.258,0,0,1,.173.686,1.606,1.606,0,0,1-.132.684,1.222,1.222,0,0,1-.353.446,1.337,1.337,0,0,1-.511.24,2.493,2.493,0,0,1-.616.072,1.663,1.663,0,0,1-.885-.182,1.231,1.231,0,0,1-.452-.453,1.3,1.3,0,0,1-.165-.544,4.289,4.289,0,0,1-.016-.471Z",
  transform: "translate(532.783 -41.676)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_36493",
  d: "M-283.287,67.082h-.617V61.9h1.07l1.307,4.352h.013l1.32-4.352h1.093v5.185h-.662v-4.61h-.013l-1.451,4.61h-.626l-1.421-4.61h-.014Z",
  transform: "translate(533.612 -41.654)",
  fill: "currentColor"
}))));

var SvgEnsure360 = function SvgEnsure360(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 255 25.23",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnsure360, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ensure360.6f0192b5.svg";
export { ForwardRef as ReactComponent };